module.exports = __webpack_public_path__ + "img/trip(16).84cb548f.webp";